import React, { useEffect, useRef } from 'react';
import { SCTeamMetricsContainer, SCTeamCardLabel, SCTeamCardNumber } from '../../globals/styles';
import { PlacingWithChange } from '../../types/types';
import styled from '@emotion/styled';
import { Tooltip } from '@mui/material';
export interface Props {
    placing: PlacingWithChange;
}

const SCTeamMetricsContainer2 = styled.div`
    display: flex;
    column-gap: 2rem;
    flex-wrap: wrap;
    @media(max-width: 800px) {
        h4 {
            text-align: center;
            width: 100%;
        }
        flex-direction: row;
        justify-content: center;
        row-gap: 1rem;
        .rank-metric, .rd-metric {
            width: 40%;
            text-align: center;
        }
        .price-metric {
            width: 100%;
        }
    }
`;

export default function SCTeamHeader({placing}:Props) {
    if (placing?.team) {
    return <SCTeamMetricsContainer2 style={{marginLeft: "auto", marginRight: "auto"}}>
            <h2 style={{textDecoration: "underline"}}>{placing.team.name}</h2>
            <Tooltip title={"Team's overall ranking for the season (change from last round)"}>
                <div className="rank-metric" style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: 'center'}}>
                    <SCTeamCardNumber style={{color: placing.position_change > -1 ? 'green' : 'red'}}>
                        {placing.position}
                        &nbsp;
                        ({placing.position_change > 0 ? '+' : ''}
                        {placing.position_change})
                    </SCTeamCardNumber>
                    <SCTeamCardLabel>Season Rank</SCTeamCardLabel>
                </div>
            </Tooltip>
            <Tooltip title={"Team's ranking for the round (change from last round)"}>
                <div className="rd-metric" style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: 'center'}}>
                    <SCTeamCardNumber style={{color: placing.rd_position_change > -1 ? 'green' : 'red'}}>
                        {placing.round_position}
                        &nbsp;
                        ({placing.rd_position_change > 0 ? '+' : ''}
                        {placing.rd_position_change})
                    </SCTeamCardNumber>
                    <SCTeamCardLabel>Last Rd Rank</SCTeamCardLabel>
                </div>
            </Tooltip>
            <Tooltip title={"The total cost of owning this team (change from last round)"}>
                <div className="price-metric" style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: 'center'}}>
                    <SCTeamCardNumber style={{color: placing.price_change > -1 ? 'green' : 'red'}}>
                        {placing.price?.toLocaleString('en-US', { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0})}
                        &nbsp;
                        ({placing.price_change > 0 ? '+' : ''}
                        {placing.price_change?.toLocaleString('en-US', { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0})})
                    </SCTeamCardNumber>
                    <SCTeamCardLabel>Price</SCTeamCardLabel>
                </div>
            </Tooltip>
        </SCTeamMetricsContainer2>
    } else {
        return <></>
    }
}